// Quiz upsell ATC Functionality
if (!customElements.get('quiz-upsell-items-lips')) {
  class QuizUpsellItems extends HTMLElement {

    constructor() {
      super();

      this.prod = this.dataset.prod;
      this.upsell = this.dataset.upsell;
      this.upsellFree = this.dataset.upsellFree;
      this.quantity = this.dataset.quantity;
      this.planTime = this.dataset.planTime;
      
      this.prodPlan = this.dataset.prodPlan;
      this.subscriptionUpsellPlan = this.dataset.subscriptionUpsellPlan;
      
      this.pageUrl = this.dataset.pageUrl;
      this.prodCitrus = this.dataset.prodCitrus;

      this.atcButton = this.querySelector('[data-quiz-lips-upsell-atc]');

      document.querySelectorAll('[data-quiz-lips-upsell-atc]').forEach(button => {
        if (button !== this.atcButton) {
          button.innerHTML = this.atcButton.innerHTML;
        }
      });

      this.fetchConfig = fetchConfig('javascript');
      this.fetchConfig.headers['X-Requested-With'] = 'XMLHttpRequest';

      this.handleClickBind = this.handleClick.bind(this);
    }

    connectedCallback() {
      window.addEventListener('click', this.handleClickBind);
    }

    addButtonAttributes() {
      document.querySelectorAll('[data-quiz-lips-upsell-atc], [data-quiz-lips-regular-atc]').forEach(button => {  
        button.setAttribute("disabled", "disabled");  
        button.classList.add('active');  
      });  
    }
    removeButtonAttributes() {
      document.querySelectorAll('[data-quiz-lips-upsell-atc], [data-quiz-lips-regular-atc]').forEach(button => {  
        button.removeAttribute("disabled");
        button.classList.remove('active');
      });  
    }
    
    handleClick(evt) {
      const upsellATCButton = evt.target.closest('[data-quiz-lips-upsell-atc]');
      const regularATCButton = evt.target.closest('[data-quiz-lips-regular-atc]');
      if (upsellATCButton) {
        this.upsellATC(true);
      } else if (regularATCButton) {
        this.upsellATC(false);
      }
    }

    // Method for Criteo tracking, which returns a Promise
    criteoTracking(itemArray, data) {
      return new Promise((resolve, reject) => {
        try {
          // Retrieve email from localStorage
          const quizUserEmail = localStorage.getItem("quizUserEmail") || "";
          //console.log('Item added to cart:', data); // Log the added item data

          window.criteo_q = window.criteo_q || [];
          const deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";

          // Prepare the items array for Criteo, mapping over itemArray to get variants
          const itemsToTrack = itemArray.map((item, index) => {
            return {
              id: item.id,  // Variant ID, not product ID
              price: Shopify.formatMoney(data.items[index].final_price),  // Access the final_price from data.items -  final price is caculated after all discounts
              quantity: item.quantity  // Quantity of the variant being added
            };
          });

          window.criteo_q.push(
            { event: "setAccount", account: 84368 },
            { event: "setEmail", email: quizUserEmail, hash_method: "sha256" },
            { event: "setEmail", email: quizUserEmail, hash_method: "md5" },
            { event: "setSiteType", type: deviceType },
            { event: "setZipcode", zipcode: this.zipCode },
            { event: "addToCart", item: itemsToTrack }
          );

          console.log(itemsToTrack);  

          // Resolve promise after the tag is fired
          resolve("Criteo Tag Fired Successfully");
        } catch (error) {
          console.error("Error in Criteo Tag:", error);
          reject(error);  // Reject the promise in case of any error
        }
      });
    }


    upsellATC(upgradeOrder) {
      const itemArray = [];


      
      if (upgradeOrder) {


        if (this.prod && this.prod !== '') {
          const upsellItem = {
            quantity: this.quantity,
            id: this.prod,
          };

          upsellItem.properties = {
            _quiz_upsell_lips: this.planTime
          }
          itemArray.push(upsellItem);
        }


        if (this.pageUrl != 'buy') {
          if (this.upsell && this.upsell !== '') {
            const upsellItem = {
              quantity: (this.pageUrl === 'buy-3x') ? 3 : 1,
              id: this.upsell,
              selling_plan: this.prodPlan,
            };
            
            upsellItem.properties = {
              _quiz_upsell_lips: this.planTime
            }
            itemArray.push(upsellItem);
          }
          if (this.prodCitrus && this.prodCitrus !== '') {
            const prodCitrus = {
              quantity: 1,
              id: this.prodCitrus,
            };
            itemArray.push(prodCitrus);
          }
        }
        else {
          if (this.upsell && this.upsell !== '') {
            const upsellItem = {
              quantity: 2,
              id: this.upsell,
            };
            
            upsellItem.properties = {
              _quiz_upsell_lips: this.planTime
            }
            itemArray.push(upsellItem);
          }
        }


        if (this.upsellFree && this.upsellFree !== '') {
          const upsellItem = {
            quantity: 1,
            id: this.upsellFree
          };

          upsellItem.properties = {
            _quiz_upsell_lips: this.planTime
          }
          itemArray.push(upsellItem);
        }


      } else {

        
        if (this.upsell && this.upsell !== '') {
          itemArray.push({
            quantity: (this.pageUrl === 'buy-3x') ? 3 : 1,
            id: this.upsell,
            selling_plan: this.prodPlan
          });
        }

        
      }




      if (itemArray.length > 0) {
        this.atc(itemArray, upgradeOrder);
      }
    }

    atc(itemArray, upgradeOrder) {
      document.body.classList.add('hide-upcart');
      this.fetchConfig.body = JSON.stringify({ 'items': itemArray });

      this.addButtonAttributes();

      fetch(routes.cart_add_url, this.fetchConfig)
        .then((response) => {
          if (response.ok) {
            return response.json(); // Parse the response JSON
          } else {
            throw new Error('Failed to add item to cart');
          }
        })
        .then((data) => {
          // Call criteoTracking and wait for it to resolve before redirecting
          this.criteoTracking(itemArray, data)
            .then(() => {
              const addCartAttribute = this.addCartAttribute(upgradeOrder)
              addCartAttribute.then(() => {
                window.location.href = '/checkout';  // Redirect after Criteo tracking
              });
            })
            .catch((error) => {
              const addCartAttribute = this.addCartAttribute(upgradeOrder)
              addCartAttribute.then(() => {
                this.removeButtonAttributes();
                console.error("Criteo Tracking failed, proceeding to checkout:", error);
                window.location.href = '/checkout';  // Redirect even if Criteo tracking fails
              });
            });
        })
        .catch((error) => {
          console.error('Error:', error);
          document.body.classList.remove('hide-upcart');
        });
    }

    addCartAttribute(upgradeOrder) {
      const attributeFetch = fetch(routes.cart_update_url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          attributes: {
            '_lip_quiz_atc': upgradeOrder ? 'LIPQUIZUPSELL' : 'LIPQUIZNOUPSELL'
          }
        }),
      })
      .then(res => res.json())
      .catch(err => console.error(err));

      return attributeFetch;
    }
  }
  customElements.define('quiz-upsell-items-lips', QuizUpsellItems);
}